export const compareTwoElements = (firstElement: any, secondElement: any) => {
  return JSON.stringify(firstElement) === JSON.stringify(secondElement);
};
